import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

const grid = 5;

const getItemStyle = (isDragging, draggableStyle, activeId, itemId) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0`,
  borderRadius: "0px",
  borderBottom: "1px solid #ccc",

  // change background colour if dragging
  background: activeId === itemId || isDragging ? "#eee" : "#fff",

  // styles we need to apply on draggables
  ...draggableStyle
});
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "#eee" : "transparent",
  padding: `${grid}px 0 ${grid}px 40px`,
  width: '100%',
  marginBottom: '20px',
  borderRadius: "10px"
});

function SortableTasks(props) {
  const getRoleDisplayname = (role) => {
    let roleIndex = props?.assigneeRoles?.findIndex((aRole) => aRole._id === role || aRole._id === role._id || aRole.name === role.name);
    if (roleIndex > -1) {
      return props?.assigneeRoles?.[roleIndex]?.name;
    } else {
      return '';
    }
  };

  useEffect(() => {
    if (props?.activeTask?.userCanComplete) {
      props.activeTask.assigneeRoles = [];
    }
  }, [props?.activeTask?.userCanComplete]);

  return (
    <Droppable key={props.index}
      droppableId={`${props.index}`}
      type={`droppableSubItem`}
      // isDropDisabled={props?.tasks?.length >= 20}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={getListStyle(snapshot.isDraggingOver)}
          {...provided.droppableProps}
        >
          {props?.tasks?.map((item, index) => {
            return (
              <Draggable
                key={item.draggableId}
                draggableId={item.draggableId}
                index={index}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style,
                      props?.activeTask?.draggableId,
                      item.draggableId
                    )}
                    onClick={() => {
                      props.selectTask(item, index, props.index);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'center'
                      }}
                    >
                      <div style={{ display: 'flex', flex: 10, alignItems: 'center' }}>
                        <span style={{ color: 'grey' }}><DragIndicatorIcon color="inherit" fontSize="medium" style={{ marginRight: '10px' }} /></span>
                        {' '}
                        {' '}
                        {item.name}
                      </div>
                      {/* <div style={{ display: 'flex', flex: 1 }}>
                        {item.duration && (
                          <div>
                            {item.duration} {`${parseInt(item.duration, 10) === 1 ? 'Day' : 'Days'}`}
                          </div>
                        )}
                      </div> */}
                      {/* <div style={{ display: 'flex', flex: 2 }}>
                        {''}
                        {item.assigneeRoles}
                      </div> */}
                      <div style={{ display: 'flex', flex: 4 }}>
                        {item.type === 'message' ? '-' : (!item.userCanComplete || item.userCanComplete === 'false' ? `${item.assigneeRoles.length > 1 ? 'Assignees' : 'Assignee'}` : 'User')}{(!item.userCanComplete || item.userCanComplete === 'false') && item.assigneeRoles.length > 0 ? (
                          <>
                            {': '}
                            {item.assigneeRoles.map((role, roleIndex) => getRoleDisplayname(role)).join(', ')}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      {/* <div style={{ display: 'flex', flex: 1 }}>

                      </div> */}
                    </div>
                  </div>
                )}
                {/* {provided.placeholder} */}
              </Draggable>
            );
          }
          )}
          {provided.placeholder}
          {snapshot.isDraggingOver && !snapshot.draggingFromThisWith && props?.tasks?.length >= 20 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px 0', color: 'red' }}>
              Maximum of 20 tasks per milestone
            </div>
          )}
        </div>
      )}
    </Droppable>
  );
}

export default SortableTasks;